<template>
    <div>
		<div class="dataTable">
			<b-row class="justify-content-lg-left"
				align-v="center"
				v-if="salesCart.items.length > 0">
				<b-col lg="12" class="cartInfo-wrap">
					<div class="addredd-left">
						<b-form>
							<b-form-group v-if="getAddressType() === '收货'"
								label="收货地址:"
								label-cols-lg="1"
								label-align-lg="right"
								label-size="sm">
								<b-form-text>
									{{addressInfo.memberDeliveryAddressContacts}}
								</b-form-text>
								<b-button size="sm" class="changeAdress"
											v-on:click="onClickChangeAddress()">变更地址</b-button>
							</b-form-group>
						</b-form>
					</div>
				</b-col>
			</b-row>
            <b-table id="sales-cart-table"
                :fields="salesCart.fields"
                :items="salesCart.items"
                small
                bordered
                hover
                show-empty
                empty-text="没有找到匹配的记录"
                :busy="salesCart.isTableBusy"
                :tbody-tr-class="cartRowClass"
                caption-top>
                <template slot="table-caption">购物车信息</template>
                <template v-slot:cell(rowSelectCheckBox)="row">
                    <b-form-checkbox v-if="row.index < salesCart.items.length - 1"
                        v-model="row.item.selected"
                        @change="salesCartItemSelectChange()">
                    </b-form-checkbox>
                    <b-form-checkbox v-else
                        v-model="salesCart.isSelectAll"
                        @change="onSelectAllSalesItems()" class="select-all">全选
                    </b-form-checkbox>
                </template>
                <template v-slot:cell(orderQuantity)="row">
                    <b-form-input v-if="row.index < salesCart.items.length - 1"
                        size="sm"
                        v-model="row.item.orderQuantity">
                    </b-form-input>
                    <span v-else>
                        {{row.item.orderQuantity}}
                    </span>
                </template>
                <template v-slot:cell(stationCanDeliveryText)="row">
                    <div v-if="row.index < salesCart.items.length - 1">
                        <a v-if="row.item.stationCanDeliveryText === '不可配送'"
                            href="#"
                            style="color:red;"
                            v-on:click="showCanDeliveryStation(row)">{{row.item.stationCanDeliveryText}}</a>
                        <span v-else>{{row.item.stationCanDeliveryText}}</span>
                    </div>
                </template>
                <template v-slot:cell(salesCartAction)="row">
                    <div v-if="row.index < salesCart.items.length - 1">
                        <a href="#"
                            v-on:click="updateProductFormSalesCart(row)">保存</a>
                        /
                        <a href="#"
                            v-on:click="deteleProductFormSalesCart(row)">删除</a>
                    </div>
                </template>
                <div slot="table-busy"
                    class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>加载中...</strong>
                </div>
            </b-table>
        </div>
		<div class="cart-order-info">
        <b-row class="justify-content-lg-bottom"
            align-v="center"
            v-if="salesCart.items.length > 0">
            <b-col lg="12" class="cartInfo-wrap">
                <b-card header="定单信息"
                    class="cartInfo">
                    <b-form>
						<b-form-group label="数量:"
						    label-cols-lg="1"
						    label-align-lg="left"
						    label-size="sm">
						    <div style=" margin-top: 4px;color: red;font-weight: bold;"> ￥{{numberToFixed(salesCart.fields.mainOrderQuantity, 4)}} </div>
						</b-form-group>
                        <b-form-group label="总额:"
                            label-cols-lg="1"
                            label-align-lg="left"
                            label-size="sm">
                            <div style=" margin-top: 4px;color: red;font-weight: bold;"> ￥{{numberToFixed(salesCart.fields.mainTotalMoney, 4)}} </div>
                        </b-form-group>
                    </b-form>
                    <div style="text-align: end;" class="cart-list-btn">
						<b-button size="sm"
						    variant="warning" v-on:click="onSubmitShopping()">
							<b-spinner small
							    v-if="salesCart.orderForm.showSubmitSpin"></b-spinner>继续选购
						</b-button>
                        <b-button size="sm"
                            variant="danger"
                            v-on:click="submitSalesOrder()">
                            <b-spinner small
                                v-if="salesCart.orderForm.showSubmitSpin"></b-spinner>提交定单
                        </b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
		</div>
    </div>
</template>

<script>
import api from "@/api/api";
import { numberToFixed, arrayUnique } from "@/libs/utils";
import "@/style/global.css";
export default {
    name: "CartList",
    data() {
        return {
			isClick:false,
            stationModal: {
                show: false,
                innerSpin: false,
                distStation: [],
                cityStation: [],
                provinceSation: [],
                otherStation: []
            },
            readContract: false,
            tabIndex: -1,
			depositBillMainVO:{},
            salesCart: {
                isTableBusy: false,
                items: [],
                fields: [
                    { key: "rowSelectCheckBox", label: "选择" },
					{ key: "sendProductDate", label:"交货日期"},
					{ key: "receiptFullAddress", label:'收货地址'},
                    { key: "productCode", label: "品种编码" },
                    { key: "productName", label: "品种名称" },
					{ key: "orderQuantity" ,label:"数量"},
					{ key: "unitName" ,label:"单位"},
                    { key: "preSalePlanPrice", label: "单价" },
                    { key: "mainTotalMoney", label: "金额" },
                    { key: "salesCartAction", label: "操作" }
                ],
                orderForm: {
                    memberDeliveryAddressUuid: this.getAddressUuid(),
                    remark: "",
                    items: [],
                    loginUuid: null,
                    itemFee: 0,
                    itemDiscountFee: 0,
                    // packageFee: 0,
                    deliveryVol: 0,
                    deliveryFee: 0,
                    showSpin: 0,
                    showSubmitSpin: false,
                    orderContract: '',
                    submitSource: 'PC'
                },
                isSelectAll: false,
                addressInfo: []
            },
        };
    },
    created() {
        let index = this.$route.query.tabIndex;
        this.tabIndex = index ? parseInt(index) : 0;
    },
    mounted() {
        if (!this.checkMemberLogin()) {
            this.$router.push({
                name: "MemberLogin"
            });
            return;
        }
        this.getCombineCartList();
        this.getAddressList();
    },
    methods: {
        numberToFixed,
		// 继续选购
		onSubmitShopping(){
			this.$router.push({
			    path: "/product/product-list",
			    query: { tabIndex: 1 }
			});
		},
        // onSelectStation(station) {
        //     let address = this.salesCart.addressList.find(e => {
        //         return e.memberDeliveryAddressStationUuid === station.distributionStationUuid;
        //     });
        //     if (address) {
        //         this.salesCart.orderForm.memberDeliveryAddressUuid = address.memberDeliveryAddressUuid;
        //         this.stationModal.show = false;
        //         this.getCombineCartList();
        //     }
        //     else {
        //         this.stationModal.innerSpin = true;
        //         api.webCopyDefaultMemberDeliveryAddress({ newStationUuid: station.distributionStationUuid }).then(res => {
        //             this.stationModal.innerSpin = false;
        //             this.stationModal.show = false;
        //             if (res.code === 0) {
        //                 let newAddress = res.data.newAddress;
        //                 this.salesCart.addressList.push(newAddress);
        //                 this.salesCart.orderForm.memberDeliveryAddressUuid = newAddress.memberDeliveryAddressUuid;
        //                 this.getCombineCartList();
        //             }
        //         });
        //     }

        // },
        getAddressList() {
            this.addressInfo = address;
            //将用户外键表的关联收货地址改为当前选中的
            api.getUserAddressInfo({addressId:address.memberDeliveryAddressUuid}).then(res => {
            	if (res.code === 0) {
            		this.preSaleOrderMainVOList.map(preSaleOrderMainVO => {
            			preSaleOrderMainVO.receiptFullAddress = res.data.receiptFullAddress;
            		})
            	}
            });
        },
        showCanDeliveryStation(row) {
            api.getSeedFarmCurSaleToDistributionStationBySeedFarm({ seedFarmUuid: row.item.seedFarmUuid }).then(res => {
                if (res.code === 0) {
                    this.stationModal.distStation = res.data.distStation;
                    this.stationModal.cityStation = res.data.cityStation;
                    this.stationModal.provinceSation = res.data.provinceSation;
                    this.stationModal.otherStation = res.data.otherStation;
                    this.stationModal.show = true;
                }
            });
        },
        getCombineCartList() {
            this.salesCart.isTableBusy = true;
            let data = { memberDeliveryAddressUuid: this.salesCart.orderForm.memberDeliveryAddressUuid };
            api.getAppPreSaleOrderList(data).then(res => {
                this.salesCart.isTableBusy = false;
				if (res.data.preSaleOrderMainVOList != null) {
                if (res.code === 0) {
                    this.depositBillMainVO = res.data.preSaleOrderMainVOList[0];
                    this.salesCart.items = res.data.preSaleOrderMainVOList[0].orderItmeList;
                    search.globalSetFilterRecordCount(this.salesCart.cartSearch, res.data.filterRecordCount);
				}	
                    let totalQuantity = 0;
                    let totalMoney = 0;
                    let totalDiscountValue = 0;

                    this.salesCart.items.forEach(e => {
                        e.selected = false;
                        e.displayPrice = this.numberToFixed(e.displayPrice, 4);
                        e.totalMoney = this.numberToFixed(e.totalMoney, 4);
                        [e.discountPrice, e.discountValue, e.discountInfo] = this.getDiscountInfo(e);
                        totalQuantity += e.orderQuantity;
                        totalMoney += e.totalMoney;
                        totalDiscountValue += e.discountValue;
                    });
                    if (this.salesCart.items.length > 0) {
                        this.salesCart.items.push({
                            orderQuantity: totalQuantity,
                            totalMoney: this.numberToFixed(totalMoney, 4),
                            discountValue: this.numberToFixed(totalDiscountValue, 4),
                            discountPrice: "合计"
                        });
                    }
                }
            });
        },
        salesCartItemSelectChange(value) {
            this.$nextTick(function () {
                let selectItems = this.salesCart.items.filter(e => {
                    return e.selected === true;
                });
                this.salesCart.orderForm.itemFee = 0;
                this.salesCart.orderForm.itemDiscountFee = 0;
                this.salesCart.orderForm.items = selectItems.map(
                    e => {
                        return { shoppingType: e.shoppingType, cartUuid: e.cartUuid };
                    }
                );
                selectItems.forEach(e => {
                    this.salesCart.orderForm.itemFee += e.totalMoney;
                    this.salesCart.orderForm.itemDiscountFee += e.discountValue;
                });
                this.readContract = false;
            });
        },
        onSelectAllSalesItems() {
            this.readContract = false;
            if (this.salesCart.isSelectAll) {
                this.salesCart.items.forEach(e => {
                    e.selected = false;
                });
                this.salesCart.orderForm.itemFee = 0;
                this.salesCart.orderForm.itemDiscountFee = 0;
                this.salesCart.orderForm.items = [];
            }
            else {
                this.salesCart.orderForm.itemFee = 0;
                this.salesCart.orderForm.itemDiscountFee = 0;
                this.salesCart.orderForm.items = this.salesCart.items
                    .slice(0, -1)
                    .map(e => {
                        return { shoppingType: e.shoppingType, cartUuid: e.cartUuid };
                    });
                this.salesCart.items.slice(0, -1).forEach(e => {
                    e.selected = true;
                    this.salesCart.orderForm.itemFee += e.totalMoney;
                    this.salesCart.orderForm.itemDiscountFee += e.discountValue;
                });
            }
        },
    
        submitSalesOrder() {
            if (this.customButtonGroup1[1].allowClick) {
				if(this.isClick ){
					return;
				}
				//判断当前小计里是否有0的订单，如果有，则提示要去除
				let zeroSign = false;
				this.preSaleOrderMainVOList.forEach((item) => {
					if (item.mainTotalMoney == 0) {
						zeroSign = true;
						return;
					}
				});
				if (zeroSign) {
					 this.$bvModal.msgBoxOk('产品金额不能为0，请取消相应的产品！');
					return;
				}
				if(this.sendProductDateArray.length==0){
					 this.$bvModal.msgBoxOk('请勾选交货日期！');
					return;
				}
				this.isClick=true;
				api.getSubmitDepositBillRecord( {sendProductDateArray:this.sendProductDateArray,addressId:this.addressInfo.memberDeliveryAddressUuid}).then(res => {
					this.isClick = false;
					if (res.code === 0) {
						this.$bvModal.msgBoxOk('稍后为您跳转到定金单页！');
						let sendProductDate = encodeURIComponent(JSON.stringify(this.sendProductDateArray));
						setTimeout(function() {
							this.$router.push({
								path: "/member/deposit-list",
								query: { tabIndex: 1 }
							});
						}, 800);
					}
				});
			}
        },
        updateProductFormSalesCart(row) {
            if (row.item.orderQuantity % row.item.productIncreaseStepAmount !== 0) {
                this.$bvModal.msgBoxOk("订购数量必须是最小订购单位的整数倍", {
                    title: "提示",
                    buttonSize: "sm",
                    size: "sm"
                });
                this.getCombineCartList();
                return;
            }
            if (row.item.orderQuantity < row.item.productMinOrderAmount) {
                this.$bvModal.msgBoxOk("订购数量必须大于最小订购量", {
                    title: "提示",
                    buttonSize: "sm",
                    size: "sm"
                });
                this.getCombineCartList();
                return;
            }
            let data = {};
            if (row.item.shoppingType === '现售') {
                data = {
                    cartItems: [
                        {
                            curSaleShoppingCartUuid: row.item.cartUuid,
                            orderQuantity: row.item.orderQuantity
                        }
                    ]
                };
                api.webCurrentSaleUpdateCart(data).then(res => {
                    if (res.code === 0) {
                        this.$bvModal.msgBoxOk("保存成功", {
                            title: "提示",
                            buttonSize: "sm"
                        });
                        this.getCombineCartList();
                    }
                });
            }
            else if (row.item.shoppingType === '预售') {
                data = {
                    cartItems: [
                        {
                            preSaleShoppingCartUuid: row.item.cartUuid,
                            orderQuantity: row.item.orderQuantity
                        }
                    ]
                };
                api.webPreSaleUpdateCart(data).then(res => {
                    if (res.code === 0) {
                        this.$bvModal.msgBoxOk("保存成功", {
                            title: "提示",
                            buttonSize: "sm"
                        });
                        this.getCombineCartList();
                    }
                });
            }
            else {

            }
        },
        deteleProductFormSalesCart(row) {
            this.$bvModal
                .msgBoxConfirm("是否确认删除该商品？", {
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "是",
                    cancelTitle: "否"
                })
                .then(value => {
                    if (value) {
                        let cartItems = [];
                        cartItems.push(row.item.cartUuid);

                        if (row.item.shoppingType === '现售') {
                            api.webCurrentSaleRemoveFromCart({
                                curSaleShoppingCartUuidList: cartItems
                            }).then(res => {
                                if (res.code === 0) {
                                    this.getCombineCartList();
                                }
                            });
                        }
                        else if (row.item.shoppingType === '预售') {
                            api.webPreSaleRemoveFromCart({
                                preSaleShoppingCartUuidList: cartItems
                            }).then(res => {
                                if (res.code === 0) {
                                    this.getCombineCartList();
                                }
                            });
                        }

                    }
                });
        },
        cartRowClass(row, type) {
            if (!row) return;
            if (row.discountPrice === "合计") {
                return "total-row-class";
            }
        },
        onClickChangeAddress() {
            this.$router.push({
                path: "/member/person-info",
                query: { tabIndex: 1 }
            });
        }
    },
    components: {}
};
</script>

<style>
.addredd-left{
	position: relative;
	left: -15px;
}
/* .addredd-left .changeAdress{
	position: relative;
	margin-right: -94rpx;
} */
.total-row-class {
    font-weight: bold;
    color: red;
}

/* .cartInfo .form-group {
    margin-bottom: 4px;
}

.cartInfo select {
    width: 40%;
}

.cartInfo input {
    width: 40%;
} */

.cartInfo{border:1px solid red;}

.deliveryInfoClass {
    color: red;
    font-size: 12px;
    font-weight: bold;
    padding-left: 20px;
}

.custom-control-label {
    padding-top: 4px;
}

.table-cloumn-max-width {
    max-width: 150px;
}
/* 部分页面共用样式名 */
/*“购物车信息”标题修改样式*/
.dataTable caption{
	color:#000000;
	font-weight: 600;
	}
/*购物车信息_表格表头样式*/
.dataTable thead th{
	background-color: #fafafa;
	border-bottom: 1px;
	line-height:40px;
	text-align: center;
	}
.dataTable input{
	text-align: left;
}
.total-row-class{
	background-color: #f8f8f8;
	line-height: 30px;
	}	
/*定金信息_标题修改样式*/		
.card-header{
	background-color: transparent;
	border: none;
	font-weight: 600;
	}
.card{
	border: none;
	}	
.cartInfo-wrap .card-body{
	border: 1px solid #efefef;
	background-color: #f8f8f8;
	border-radius: 5px;
	padding:20px;
	}	
.cartInfo-wrap .card-header{text-align:left;}

.cartInfo-wrap .ivu-select-input{background-color:#fff;border:1px solid #efefef;}

.cartInfo-wrap .form-control-sm{background-color:#fff;border:1px solid #efefef;}
/*定金信息_查查看种苗定购协议按钮修改样式*/		


/* 全选按钮 */
 .select-all .custom-control-label{padding-top: 0px;}
 /* 表格总计行鼠标移动样式 */
 .table-hover tbody .total-row-class:hover{color: red; background-color: #f8f8f8;font-weight: bold;}
 
 /* 表格操作 */
 .table-sm td a{color:#00B151;}
 
 .cart-order-info .row{margin-right:0px;margin-left:0px;}
 .cartInfo-wrap{padding-left:0px;padding-right:0px;}
 
 
 /* 提交订单和查看种苗定购协议按钮 */
  .cart-list-btn .btn-success.disabled, .cart-list-btn .btn-success:disabled{color: #fff;background-color: #1da25a;border-color: #1da25a;}
  .cart-list-btn .btn.disabled, .cart-list-btn .btn:disabled{opacity: 100;}
  .cart-list-btn .btn-warning{color:#fff;    background-color: #e5ad06; border-color: #e5ad06;}
 .cart-list-btn .btn-warning:hover{color:#fff;}
 .cart-list-btn .btn-warning.focus, .cart-list-btn .btn-warning:focus{color:#fff;}
 
 .col, .col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col-auto, .col-lg, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-auto, .col-md, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md-auto, .col-sm, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-auto{padding-left:0px;padding-right:0px;}
</style>



// WEBPACK FOOTER //
// src/view/member/cart-list.vue